import React, { lazy } from 'react';

import { hasDefaultExport, withStaleChunkRecovery } from '@/libs/IdeLink.Web.Common/src/utils/staleChunkRecovery';

// Une build périmée peut résoudre le chunk d'une app client vers un module sans
// export default : sans recovery, l'écran reste vide (Sentry IDELINK-FG).
const lazyApp = (chunkImport: () => Promise<{ default: React.ComponentType }>) => lazy(withStaleChunkRecovery(chunkImport, hasDefaultExport));

const VapolinkApp = lazyApp(() => import('./clients/vapolink/VapolinkApp'));
const FluizyApp = lazyApp(() => import('./clients/fluizy/FluizyApp'));
const IdelinkApp = lazyApp(() => import('./clients/idelink/IdelinkApp'));
const IrritalkApp = lazyApp(() => import('./clients/irritalk/IrritalkApp'));
const MidaslinkApp = lazyApp(() => import('./clients/midaslink/MidaslinkApp'));
const ETribuApp = lazyApp(() => import('./clients/sylviethiriez/ETribuApp'));
const Auto5LinkApp = lazyApp(() => import('./clients/auto5link/Auto5LinkApp'));
const OBlinkApp = lazyApp(() => import('./clients/oblink/OBlinkApp'));
const FootKornerLinkApp = lazyApp(() => import('./clients/footkornerlink/FootKornerLinkApp'));
const AcuitislinkApp = lazyApp(() => import('./clients/acuitislink/AcuitislinkApp'));
const EngagedApp = lazyApp(() => import('./clients/engaged/EngagedApp'));
const PharmavanceApp = lazyApp(() => import('./clients/pharmavance/PharmavanceApp'));
const BasilinkApp = lazyApp(() => import('./clients/basilink/BasilinkApp'));
const NipponlinkApp = lazyApp(() => import('./clients/nipponlink/NipponlinkApp'));
const KapaApp = lazyApp(() => import('./clients/kapa/KapaApp'));
const FoirfouillelinkApp = lazyApp(() => import('./clients/foirfouillelink/FoirfouillelinkApp'));
const EntrenousApp = lazyApp(() => import('./clients/entrenous/EntreNousApp'));
const MeryPlusApp = lazyApp(() => import('./clients/meryplus/MeryPlusApp'));
const CrechesPlusApp = lazyApp(() => import('./clients/crechesplus/CrechesPlusApp'));
const GemgusApp = lazyApp(() => import('./clients/gemgus/GemGusApp'));
const ChronolinkApp = lazyApp(() => import('./clients/chronolink/ChronolinkApp'));
const EmovalinkApp = lazyApp(() => import('./clients/emova/EmovaApp'));
const KandyApp = lazyApp(() => import('./clients/kandyfees/KandyFeesApp'));
const NozlinkApp = lazyApp(() => import('./clients/nozlink/NozApp'));
const AdeolinkApp = lazyApp(() => import('./clients/adeolink/AdeolinkApp'));
const YellowlinkApp = lazyApp(() => import('./clients/yellowlink/YellowlinkApp'));
const DimlinkApp = lazyApp(() => import('./clients/dimlink/DimlinkApp'));
const GalinkApp = lazy(() => import('./clients/galink/GalinkApp'));
const CactuslinkApp = lazyApp(() => import('./clients/cactuslink/CactuslinkApp'));
const PiloteApp = lazyApp(() => import('./clients/pilote/PiloteApp'));

export enum IdelinkCustomerApp {
	DEMOLINK = 'DEMOLINK',
	FLUIZY = 'FLUIZY',
	IDELIEN = 'IDELIEN',
	IRRITALK = 'IRRITALK',
	MIDASLINK = 'MIDASLINK',
	NOZLINK = 'NOZLINK',
	SYLVIETHIRIEZ = 'SYLVIETHIRIEZ',
	VAPOLINK = 'VAPOLINK',
	AUTO5LINK = 'AUTO5LINK',
	OBLINK = 'OBLINK',
	FOOTKORNERLINK = 'FOOTKORNERLINK',
	ACUITISLINK = 'ACUITISLINK',
	ENGAGED = 'ENGAGED',
	PHARMAVANCE = 'PHARMAVANCE',
	BASILINK = 'BASILINK',
	NIPPONLINK = 'NIPPONLINK',
	KAPA = 'KAPA',
	FOIRFOUILLELINK = 'LAFOIRFOUILLELINK',
	ENTRENOUS = 'ENTRENOUS',
	MERYPLUS = 'MERYPLUS',
	CRECHESPLUS = 'CRECHESPLUS',
	GEMGUS = 'GEMGUS',
	CHRONOLINK = 'CHRONOLINK',
	EMOVALINK = 'EMOVALINK',
	KANDY = 'KANDYFEES',
	ADEOLINK = 'ADEOLINK',
	YELLOWLINK = 'YELLOWLINK',
	DIMLINK = 'DIMLINK',
	GALINK = 'GALINK',
	CACTUSLINK = 'CACTUSLINK',
	PILOTE = 'PILOTE',
}

//PGU TODO: J'ai été obligé de mettre chaque app en lazy loading. Sans ça toutes les apps sont chargées pour chaque client.
// ça pose bien évidemment un problème de performance.
// mais ça pose aussi un problème de style puisque les fichier css de toutes les app sont chargés pour chaque client.
// l'idéal serait d'avoir un fichier index.tsx différent pour chaque client.  >>> TODO!
export class IdelinkLauncher {
	public static getApp = (app: IdelinkCustomerApp | '__APP__'): React.ComponentType => {
		switch (app) {
			case IdelinkCustomerApp.DEMOLINK:
			case IdelinkCustomerApp.IDELIEN:
				return IdelinkApp;
			case IdelinkCustomerApp.MIDASLINK:
				return MidaslinkApp;
			case IdelinkCustomerApp.FLUIZY:
				return FluizyApp;
			case IdelinkCustomerApp.IRRITALK:
				return IrritalkApp;
			case IdelinkCustomerApp.SYLVIETHIRIEZ:
				return ETribuApp;
			case IdelinkCustomerApp.VAPOLINK:
				return VapolinkApp;
			case IdelinkCustomerApp.AUTO5LINK:
				return Auto5LinkApp;
			case IdelinkCustomerApp.OBLINK:
				return OBlinkApp;
			case IdelinkCustomerApp.FOOTKORNERLINK:
				return FootKornerLinkApp;
			case IdelinkCustomerApp.ACUITISLINK:
				return AcuitislinkApp;
			case IdelinkCustomerApp.ENGAGED:
				return EngagedApp;
			case IdelinkCustomerApp.PHARMAVANCE:
				return PharmavanceApp;
			case IdelinkCustomerApp.BASILINK:
				return BasilinkApp;
			case IdelinkCustomerApp.NIPPONLINK:
				return NipponlinkApp;
			case IdelinkCustomerApp.KAPA:
				return KapaApp;
			case IdelinkCustomerApp.FOIRFOUILLELINK:
				return FoirfouillelinkApp;
			case IdelinkCustomerApp.ENTRENOUS:
				return EntrenousApp;
			case IdelinkCustomerApp.MERYPLUS:
				return MeryPlusApp;
			case IdelinkCustomerApp.CRECHESPLUS:
				return CrechesPlusApp;
			case IdelinkCustomerApp.GEMGUS:
				return GemgusApp;
			case IdelinkCustomerApp.CHRONOLINK:
				return ChronolinkApp;
			case IdelinkCustomerApp.EMOVALINK:
				return EmovalinkApp;
			case IdelinkCustomerApp.KANDY:
				return KandyApp;
			case IdelinkCustomerApp.NOZLINK:
				return NozlinkApp;
			case IdelinkCustomerApp.ADEOLINK:
				return AdeolinkApp;
			case IdelinkCustomerApp.YELLOWLINK:
				return YellowlinkApp;
			case IdelinkCustomerApp.DIMLINK:
				return DimlinkApp;
			case IdelinkCustomerApp.GALINK:
				return GalinkApp;
			case IdelinkCustomerApp.CACTUSLINK:
				return CactuslinkApp;
			case IdelinkCustomerApp.PILOTE:
				return PiloteApp;
		}
		return IdelinkApp;
	};
}
